import { FilterOperator, MetricView } from '@nemuru-eng/js-api-client';

import { QueryBuilder } from '../QueryBuilder';
import { MetricFilter } from './MetricFilter';

type CustomMetricView = MetricView & { channelId: string };

export class ChannelIdFilter extends MetricFilter<string> {
  public field = 'channel_id';
  public operator = FilterOperator.IN;

  constructor(channelId?: string[]) {
    super(channelId);
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    const newFilter = newQueryBuilder.metricFilter<ChannelIdFilter>(this);
    if (this.areValuesIncluded(newFilter)) return false;
    return true;
  }

  public merge(newFilter: ChannelIdFilter): this {
    if (!(newFilter instanceof ChannelIdFilter)) return this;
    if (newFilter.values === undefined) return new ChannelIdFilter(undefined) as this;
    if (this.areValuesIncluded(newFilter)) return this;
    const uniqueValues = Array.from(new Set([...this.values, ...newFilter.values]));
    return new ChannelIdFilter(uniqueValues) as this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    if (!this.values) return metrics;
    return (metrics as unknown as CustomMetricView[]).filter((metric) =>
      this.values.some((value) => value === metric.channelId),
    ) as unknown as K[];
  }
}
